// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1SWRi","inputDescription":"styles_inputDescription__3jQUN"};